import React from 'react'
import './FairnessModal.scss'
import { TOWER_DIFFICULTY_LEVELS } from 'games/TowerGame/tower.constants'

const TowerFairnessModalResult = (props) => {
  const { provableFairResult = null, towerGameConfig } = props
  const { minePositions = null, advanceMultiplierPosition = null } = provableFairResult?.tower || {}

  const renderGridSection = (level) => {
    return (
      <>
        <div
          key={`game-levels-${level}`}
          className={`position-relative grid-section ${towerGameConfig.difficultyType}`}
        >
          {/* create columns count based on difficulty level */}
          {Array.from(
            {
              length: TOWER_DIFFICULTY_LEVELS.find(
                ({ difficulty }) => difficulty === towerGameConfig.difficultyType
              )?.columnsPerLevel
            },
            (_, idx) => idx
          ).map((tileNumber) => (
            <div
              key={`game-levels-cell-${tileNumber}`}
              className={getTileClassName({ level, tileNumber })}
            />
          ))}
        </div>
      </>
    )
  }

  const getTileClassName = ({ level, tileNumber }) => {
    if (advanceMultiplierPosition?.[0] === level && advanceMultiplierPosition?.[1] === tileNumber) {
      return getAdvMultiplerClass({ advanceMultiplierPosition, level, tileNumber })
    } else if (minePositions?.[level].includes(tileNumber)) {
      return 'tile mine'
    }
    return 'tile'
  }

  const getAdvMultiplerClass = ({
    advanceMultiplierPosition,
    level,
    tileNumber,
    className = ''
  }) => {
    if (advanceMultiplierPosition[0] === level && advanceMultiplierPosition[1] === tileNumber) {
      // if this level and tile contains multiplier
      const advMultiplierLevel = advanceMultiplierPosition[0]
      const advMultiplierTilePos = advanceMultiplierPosition[1]
      switch (advMultiplierLevel) {
        case 2:
          if (advMultiplierTilePos === tileNumber) {
            return `tile x2 ${className}`
          }
        case 5:
          if (advMultiplierTilePos === tileNumber) {
            return `tile x5 ${className}`
          }
        case 8:
          if (advMultiplierTilePos === tileNumber) {
            return `tile x10 ${className} `
          }
      }
    }
  }

  return (
    <div className='tower-game-container position-relative'>
      {
        // create 9 levels from 0 -> 8
        Array.from({ length: 9 }, (_, idx) => 8 - idx).map((level) => renderGridSection(level))
      }
    </div>
  )
}

export default TowerFairnessModalResult
